import { INGESTION_CONSTANTS } from 'Modules/Studio/components/StudioInfo/Ingestion/utilities/Ingestion.constants';
import { IActiveIngestion } from 'Modules/Studio/components/StudioInfo/redux/ingestion.interface';
import { INGESTION_BY_TABLE_TEXT } from '../../../IngestionByDataSource.constants';

/**
 * Returns whether there is an active ingestion (running) at data source level or at table level
 * @param activeIngestion
 * @returns boolean
 */
export const getDSViewIsRunningIngestion = (activeIngestion: IActiveIngestion | null): boolean => {
  const isRunningAtDSLevel = activeIngestion?.status === INGESTION_CONSTANTS.RUNNING;

  const isRunningAtTableLevel =
    activeIngestion !== null &&
    Object.values(activeIngestion?.tables || {}).some(
      (table) => table.status === INGESTION_CONSTANTS.RUNNING
    );

  return isRunningAtDSLevel || isRunningAtTableLevel;
};

/**
 * Returns whether the ingestion button should be disabled at data source view
 * @param activeIngestion
 * @returns boolean
 */
export const getDSViewIsDisabled = (activeIngestion: IActiveIngestion | null): boolean => {
  const isStoppingAtDSLevel = activeIngestion?.status === INGESTION_CONSTANTS.TRIGGERED_STOP;

  const isStoppingAtTableLevel =
    activeIngestion !== null &&
    Object.values(activeIngestion?.tables || {}).some(
      (table) => table.status === INGESTION_CONSTANTS.TRIGGERED_STOP
    );

  return isStoppingAtDSLevel || isStoppingAtTableLevel;
};

export const getDSViewToolTipText = (
  isDisabled: boolean,
  isRunning: boolean,
  isFullIngestionActive: boolean
): string => {
  if (isFullIngestionActive) {
    return INGESTION_BY_TABLE_TEXT.tooltips.disabled.fullRunning;
  }

  if (isDisabled) {
    return INGESTION_BY_TABLE_TEXT.tooltips.disabled.stopping;
  }

  return isRunning
    ? INGESTION_BY_TABLE_TEXT.tooltips.stopDS
    : INGESTION_BY_TABLE_TEXT.tooltips.startDS;
};
